/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A11Inputs */

const en_pc_faq_a11 = /** @type {(inputs: Pc_Faq_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is an optional installer from ArtCraft that sets up PdfCraft and the other Craft Apps, then keeps them updated. If you only want PdfCraft, the direct download works just as well.`)
};

const zh_pc_faq_a11 = /** @type {(inputs: Pc_Faq_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是 ArtCraft 提供的可选安装器，可以安装 PdfCraft 和其他 Craft Apps，并自动保持更新。如果只需要 PdfCraft，直接下载安装包也完全可以。`)
};

/**
* | output |
* | --- |
* | "It is an optional installer from ArtCraft that sets up PdfCraft and the other Craft Apps, then keeps them updated. If you only want PdfCraft, the direct down..." |
*
* @param {Pc_Faq_A11Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a11 = /** @type {((inputs?: Pc_Faq_A11Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A11Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a11(inputs)
	return zh_pc_faq_a11(inputs)
});
export { pc_faq_a11 as "pc.faq.a11" }